import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLTrackElement extends HTMLElement { constructor(tagName: string = 'TRACK', ownerDocument?: any) { super(tagName, ownerDocument); } }
